import { render, staticRenderFns } from "./ServerInfo.vue?vue&type=template&id=4e001f01&scoped=true"
import script from "./ServerInfo.vue?vue&type=script&lang=js"
export * from "./ServerInfo.vue?vue&type=script&lang=js"
import style0 from "./ServerInfo.vue?vue&type=style&index=0&id=4e001f01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e001f01",
  null
  
)

export default component.exports